// Market data strip — update ITEMS when running daily update
const ITEMS = [
  { label: 'S&P 500',  price: '7 580',   change: '-1.82%', pos: false },
  { label: 'NASDAQ',   price: '25 437',  change: '-2.86%', pos: false },
  { label: 'DOW',      price: '51 770',  change: '-1.09%', pos: false },
  { label: 'Gold',     price: '$3 899',  change: '-3.3%',  pos: false },
  { label: 'EUR/USD',  price: '1.12',    change: 'Okt. −1.2%', pos: false },
  { label: 'Brent',    price: '$117.64', change: '+2.4%',  pos: true  },
  { label: '10Y US',   price: '4.93%',   change: '−14bp s. 16.10.', pos: true },
  { label: 'VIX',      price: '19.4',    change: 'nahe 3M-Hoch', pos: false },
  { label: 'Bitcoin',  price: '$77 400', change: 'Okt. −8%', pos: false },
]

export default function Ticker() {
  const items = [...ITEMS, ...ITEMS]

  return (
    <div
      className="relative flex items-stretch overflow-hidden"
      style={{
        height: '36px',
        background: 'var(--surface)',
        borderBottom: '1px solid rgba(101,116,248,0.10)',
      }}
    >
      {/* MKTS label */}
      <div
        className="shrink-0 flex items-center px-4 gap-2 z-10"
        style={{
          background: 'linear-gradient(135deg, rgba(101,116,248,0.12) 0%, rgba(167,139,250,0.06) 100%)',
          borderRight: '1px solid rgba(101,116,248,0.15)',
        }}
      >
        <span className="w-1.5 h-1.5 rounded-full bg-live animate-pulse-live shrink-0" aria-hidden="true" />
        <span className="font-mono text-[8px] font-bold tracking-[0.18em] uppercase" style={{ color: '#A78BFA' }}>MKTS</span>
      </div>

      {/* Scrolling strip */}
      <div
        className="ticker-strip flex-1 relative"
        style={{
          maskImage: 'linear-gradient(to right, transparent 0%, black 3%, black 97%, transparent 100%)',
          WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 3%, black 97%, transparent 100%)',
        }}
      >
        <div className="ticker-inner h-full items-center">
          {items.map((item, i) => (
            <span key={i} className="inline-flex items-center h-full">
              <span
                className="inline-flex items-center gap-2.5 px-5 h-full"
                style={{ borderRight: '1px solid rgba(255,255,255,0.05)' }}
              >
                <span className="font-mono text-[8px] font-bold tracking-[0.14em] uppercase" style={{ color: 'var(--text-3)' }}>
                  {item.label}
                </span>
                <span className="font-mono text-[11px] font-bold tabular-nums text-t1">
                  {item.price}
                </span>
                <span
                  className="font-mono text-[9px] font-bold tabular-nums"
                  style={{ color: item.pos ? 'var(--pos)' : 'var(--neg)' }}
                >
                  {item.pos ? '▲' : '▼'} {item.change}
                </span>
              </span>
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}
